<template>
  <div id="app">
    <div class="app-content">
      <div class="navMenu">
        <router-view name="menu"></router-view>
      </div>
      <div class="mainContent">
        <div class="header" @click="closeMenu">
          <router-view name="header"></router-view>
        </div>
        <div class="container" @click="closeMenu">
          <router-view name="content"></router-view>
        </div>
      </div>
    </div>
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      screenWidth: document.documentElement.clientWidth || document.body.clientWidth
    }
  },
  methods: {
    closeMenu: function() {
      if (this.screenWidth < 850) {
        this.$store.commit('getSliderStatus', false)
      }
    },
    handleResize(event) {
      this.screenWidth = document.documentElement.clientWidth
    }
  },
  created() {
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy: function() {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /*text-align: center;*/
  color: #2c3e50;
  /*margin-top: 60px;*/
}
.app-content {
  display: flex;
  height: 100%;
  overflow: hidden;
}
.navMenu {
  height: 100%;
}

.mainContent {
  flex: 1;
  background: #f3f6fe;
  height: 100vh;
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/App.vue